import { render, staticRenderFns } from "./freightStandard.vue?vue&type=template&id=324f270c&"
import script from "./freightStandard.vue?vue&type=script&lang=js&"
export * from "./freightStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324f270c')) {
      api.createRecord('324f270c', component.options)
    } else {
      api.reload('324f270c', component.options)
    }
    module.hot.accept("./freightStandard.vue?vue&type=template&id=324f270c&", function () {
      api.rerender('324f270c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/freightStandard.vue"
export default component.exports